module.exports = "<h1 class=\"error-message\">Page Not Found.</h1>\n<p class=\"error-details\"><a [href]=\"platformUiUrl\">Go Home</a></p>\n"


//////////////////
// WEBPACK FOOTER
// ./src/app/pages/errors/not-found/not-found.page.html
// module id = ./src/app/pages/errors/not-found/not-found.page.html
// module chunks = main